(function () {
    'use strict';

    angular
        .module('app.core')
        .config(singleSignOnTransitionHook);

    var globals = window['@uirouter/angularjs'],
        rSingleSignOn = /\/login\/(?:([0-9A-F]{8}[-]?(?:[0-9A-F]{4}[-]?){3}[0-9A-F]{12})|(\d+)\/([A-Z0-9]+))/i,
        slice = Array.prototype.slice,
        identity = angular.identity;

    singleSignOnTransitionHook.$inject = ['$urlServiceProvider'];
    function singleSignOnTransitionHook($urlServiceProvider) {
        $urlServiceProvider.rules.when(rSingleSignOn, proxy);

        function proxy(match) {
            globals.services.$injector.invoke(handler, this, { match: match });
        }

        handler.$inject = ['$q', '$state', 'signInManager', 'user', 'parseStateUrl', 'match', 'clubAdminStateName', 'associationAdminStateName', 'homeStateName'];
        function handler($q, $state, signInManager, user, parseStateUrl, match, clubAdminStateName, associationAdminStateName, homeStateName) {
            var args = [match[1], +match[2], match[3]].filter(identity);

            signInManager.signIn.apply(signInManager, args)
                .then(findTargetState)
                .catch(defaultTargetState)
                .then(transition);

            function findTargetState(token) {
                var redirectUrl = token.redirect_uri;
                delete token.redirect_uri;
                return redirectUrl ? parseStateUrl(redirectUrl) : $q.reject();
            }

            function defaultTargetState() {
                return $state.target(user.isAssociationAdmin ? associationAdminStateName : user.isAdmin ? clubAdminStateName : homeStateName);
            }

            function transition(target) {
                $state.go(target.state(), target.params(), target.options());
            }
        }
    }
})();
